export default function OurStory() {
  return (
    <section className="py-28 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h3 className="text-5xl font-bold text-[#2B2B2B] leading-tight mb-8">
              How It All<br />
              <span className="font-serif italic">Began</span>
            </h3>
            <div className="space-y-5 text-gray-600 leading-relaxed">
              <p>
                Design Assist was founded by a team of interior design industry veterans who understood firsthand how frustrating and fragmented the procurement process could be. Hours wasted chasing vendors, navigating trade account applications, managing multiple supplier relationships — all while trying to focus on the creative work that matters most.
              </p>
              <p>
                We saw talented designers lose time, margin, and momentum because the back-end of the business simply wasn&apos;t built to support them. So we built something that was.
              </p>
              <p>
                Today, Design Assist serves as the single point of contact between interior design professionals and the world&apos;s leading trade vendors — from furniture and lighting to textiles, hardware, and custom fabrication. We consolidate relationships, streamline orders, and manage logistics so you can do what you do best: design.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden w-full h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/75028f9199f186aaceb6edd2646151cd.jpg"
                alt="Design Assist founding story"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#2B2B2B] text-white px-8 py-6 rounded-2xl">
              <div className="text-4xl font-bold text-[#C5A572]">7+</div>
              <div className="text-sm text-gray-300 mt-1">Years in the Industry</div>
            </div>
            <div className="absolute -top-6 -right-6 bg-[#C5A572] text-white px-8 py-6 rounded-2xl">
              <div className="text-4xl font-bold">500+</div>
              <div className="text-sm text-white/80 mt-1">Trade Vendors</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
